// 计入能量map
export const CAL_ANGE_MAP = {
    '0': '不计入',
    '1': '计入'
}